import { DESIGN_RECIPES } from '../designRecipes';
/** Complete canonical text roles for the DOM renderers that do not load recipe CSS. */
export function typographyCss(role) {
    return Object.entries(DESIGN_RECIPES.text[role])
        .map(([property, value]) => `${property.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`)}:${value}`)
        .join(';');
}
//# sourceMappingURL=typographyCss.js.map